import { lazy, Suspense } from "react";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import DeferredMount from "@/components/DeferredMount";

const BookingWidget = lazy(() => import("@/components/BookingWidget"));

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-secondary">
      <div className="container">
        <div className="text-center mb-14">
          <p className="text-primary-strong font-semibold text-sm uppercase tracking-widest mb-3">Get In Touch</p>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-foreground">
            Visit Us Today
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-card rounded-2xl p-8 space-y-6" style={{ boxShadow: "var(--shadow-card)" }}>
            {[
              { icon: Phone, label: "Phone", value: "(678) 236-0376", href: "tel:+16782360376" },
              { icon: Mail, label: "Email", value: "info@computerzoneatlanta.com", href: "mailto:info@computerzoneatlanta.com" },
              { icon: MapPin, label: "Location", value: "3079 Roswell Rd, Marietta, GA 30062", href: "https://www.google.com/maps/search/?api=1&query=3079+Roswell+Rd+Marietta+GA+30062" },
              { icon: Clock, label: "Hours", value: "Mon–Fri: 9AM–5PM · Sat–Sun: 12–3PM", href: "#" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="flex items-start gap-4 group"
              >
                <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <item.icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground uppercase tracking-wider">{item.label}</p>
                  <p className="font-medium text-foreground group-hover:text-primary transition-colors">{item.value}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="rounded-2xl overflow-hidden min-h-[360px]">
            <iframe
              title="Computer Zone Atlanta Location"
              src="https://www.google.com/maps?q=Computer+Zone+3079+Roswell+Rd+Marietta+GA+30062&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 360 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        {/* Booking Widget */}
        <div id="booking" className="scroll-mt-24">
          <div className="text-center mb-8">
            <p className="text-primary-strong font-semibold text-sm uppercase tracking-widest mb-3">Book Now</p>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-foreground">
              Schedule Your Free 15-Minute Diagnostic
            </h2>
            <p className="text-muted-foreground mt-3 max-w-xl mx-auto">
              Bring your device in for a complimentary 15-minute diagnostic. No commitment, no pressure — just honest answers from Marietta's trusted tech team.
            </p>
          </div>
          <DeferredMount when="visible" minHeight={560}>
            <Suspense fallback={null}>
              <BookingWidget />
            </Suspense>
          </DeferredMount>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
